import { useState, useEffect } from "react";
import { InputBox, SubmitButton } from "../../components/Input";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";
import CompanyHeader from "./CompanyHeader";

const WhatsappConfigForm = () => {
  const [formData, setFormData] = useState({
    wp_api_key: "",
    wp_api_url: "",
    wp_default_number: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");

  // Fetch data from an API or load it dynamically here
  const fetchCompany = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}settings/company/Configurations`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setFormData(response.data.data || {});
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_URL}settings/company/configuration/save?id=${formData.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success === true) {
        showToast.success(response.data.message);
        fetchCompany();
      } else {
        showToast.error(response.data.message);
      }
    } catch (error) {
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <CompanyHeader />
        <div className="panel panel-default with-rounded-corner with-shadow mt-3">
          <form onSubmit={handleSubmit}>
            <div className="panel-heading border-0">
              <span className="panel-title">
                Edit Whatsapp API Configuration
              </span>
            </div>
            <div className="panel-body mt-2">
              <div className="row">
                {/* API URL */}
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="API URL"
                    fieldname="wp_api_url"
                    value={formData.wp_api_url}
                    onChange={handleChange}
                    placeholder="Enter API URL"
                  />
                </div>

                {/* API Key */}
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="API Key"
                    fieldname="wp_api_key"
                    value={formData.wp_api_key}
                    onChange={handleChange}
                    placeholder="Enter API Key"
                  />
                </div>

                {/* Default Number */}
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="Default Number"
                    fieldname="wp_default_number"
                    value={formData.wp_default_number}
                    onChange={handleChange}
                    placeholder="Enter Default Number"
                  />
                </div>
              </div>

              <div className="clearfix"></div>
              <SubmitButton
                pageBack="/Settings/Company"
                handleSubmit={handleSubmit}
              />
            </div>
          </form>
        </div>

        {/* Scroll to Top Button */}
        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default WhatsappConfigForm;
